<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <a-form>
        <a-form-item
          label="活动界次"
          :labelCol="{ xs: { span: 8 }, sm: { span: 2 } }"
          :wrapperCol="{ xs: { span: 16 }, sm: { span: 22 } }"
        >
          <j-dict-select-tag
             @change="eventChange"
            :defaultShowAll="true"
            type="radioButton"
            v-model="queryParam.eventId"
            dictCode="event_orders"
            :trigger-change="true"
          />
        </a-form-item>
        <a-form-item
          label="排序方式"
          :labelCol="{ xs: { span: 8 }, sm: { span: 2 } }"
          :wrapperCol="{ xs: { span: 16 }, sm: { span: 22 } }"
        >
          <a-radio-group
            button-style="solid"
            @change="getList"
            v-model="queryParam.orderBy"
          >
            <a-radio-button value="star"> 推荐 </a-radio-button>
            <a-radio-button value="time"> 最新提交 </a-radio-button>
            <a-radio-button value="view"> 查看最多 </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <a-divider />
      <a-list
        :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="work-card">
            <a @click="toDetail(item.id)" target="_blank">
              <img
                class="work-cover"
                v-if="item.coverFileKey"
                :src="item.coverFileKey_url"
              />
              <img v-if="item.workType == 4" src="../assets/python.png" alt="" />
            </a>
            <a-row type="flex" justify="end">
              <a-col :span="5">
                <a-icon type="eye" /> {{ item.viewNum }}
              </a-col>
              <a-col :span="5">
                <a-icon type="like" /> {{ item.starNum }}
              </a-col>
            </a-row>
            <p>{{ item.workName }}</p>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  icon="user"
                  class="avatar"
                  :size="40"
                  :src="item.avatar_url"
                />
              </a-col>
              <a-col :span="18">
                <span>{{ item.realname || item.username }}</span>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
import "@/assets/less/animation.css";

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    PhotoCard,
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12,
      },
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        pageSize: 999,
        eventId:'',
        orderBy: 'star',
        orderBy: 'time'
      },
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted() {},
  methods: {
    eventChange(v){
      this.queryParam.eventId = v.target.value
      this.getList()
    },
    getList() {
      getAction("/teaching/teachingWork/leaderboard", this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
        }
      });
    },
    toDetail(id) {
      // this.$router.push('/event/workDetail?id='+id)
      let route = this.$router.resolve({
        path: "/event/workDetail",
        query: {
          id: id,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.img-zoom {
  width: 100%;
  height: 170px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  cursor: pointer;
  .ant-card-body {
    // padding: 0;
  }
}

  .work-card {
    border-radius: 10px;
    // box-shadow: grey 2px 2px 5px;
    width: 250px;
    height: 300px;
    .work-cover {
      width: 100%;
      max-height: 150px;
    }
    .work-author{
      span{
        line-height: 40px;
      }
    }
  }

.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>